import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/confirm-private-email/page";

export const Route = createFileRoute("/auth/confirm-private-email")({
  component: Page,
});
